import globalActions from '../api/GlobalActions.js'
import globalMutations from '../api/GlobalMutations.js'
import globalGetters from '../api/GlobalGetters.js'

export const state = () => ({
  isStale: true,
  latest_fetch: '',
  type: 'extras',
  pageLayout: 'LayoutStructureTable',
  canEdit: false,
  canView: false,
  inlineEdit: true,
  modelLabels: {
    single: 'Extra',
    plural: 'Extras'
  },
  filterOverrides: [],
  aliasField: 'alias',
  relations: [
    {
      name: 'mounts',
      translate: 'mounts',
      label: 'Mounts',
      value: 'mounts',
      storename: 'mounts',
      export: false
    },
    {
      name: 'tags',
      translate: 'tags',
      label: 'Tags',
      value: 'tags',
      storename: 'tags',
      export: true
    }
  ],
  all: {},
  active: false,
  searchFields: ['name', 'alias', 'override_name'],
  bound: {
    name: ''
  },
  filter: {},
  quickFilters: [],
  stub: {},
  include: ''
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
